import React, {Component} from "react";

import {View, Text, TouchableOpacity, ActivityIndicator}  from 'react-native'

import cores from '../util/cores'

import dimens from '../util/dimens'

import {estilos} from '../util/estilos'

import * as texto from '../util/texto'




export default class  Botao extends Component {


    
    constructor(props) {
        
        super(props);
        
        this.state = {carregando:       false};
    }


    setCarregando(valor){

        this.setState({carregando: valor});
    }

    
    render() {
        
        if(this.state.carregando)
            return (
            <View style={[{flex:1,
							alignItems:'center',
							padding: 20,
							marginTop:12
						}, estilos.grade]}>
                <ActivityIndicator size="large" color={cores.azul} animating={this.state.carregando}/>
            </View>)

        if(this.props.somente_texto!=null && this.props.somente_texto==true)
			return (
				<TouchableOpacity 
					onPress={()=>this.props.acao()}
					style={[{backgroundColor: cores.fundo_claro,
								paddingLeft: 10,
								paddingRight: 10,
								borderRadius:5,
								paddingVertical:8,
								justifyContent: 'center',
								alignItems:'center',
								borderColor: (texto.isBlanck(this.props.cor)?cores.azul:this.props.cor),
								borderWidth:1}, estilos.sombra]}>
					<View> 
						<Text style={{color:cores.fonte_escura, fontSize:dimens.fonte_rotulo}}>{this.props.texto}</Text>
					</View>
				</TouchableOpacity>)
				
		return (<TouchableOpacity 
					onPress={()=>this.props.acao()}
					style={[{backgroundColor:  this.props.cor ==null?cores.azul:this.props.cor,
								paddingLeft: 10,
								paddingRight: 10,
								borderRadius:4,
								paddingVertical:8,
								marginTop:10,
								justifyContent: 'center',
								alignItems:'center'}, estilos.sombra]}>
					<View style={estilos.grade}> 					
						<Text style={{color:cores.fonte_clara, fontSize:dimens.fonte_rotulo}}>{this.props.texto}</Text>
					</View>
				</TouchableOpacity>)
   }
} 